import { render, staticRenderFns } from "./WorkshiftList.vue?vue&type=template&id=7e1d19d4&"
import script from "./WorkshiftList.vue?vue&type=script&lang=js&"
export * from "./WorkshiftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports